export default __webpack_public_path__ + "static/media/Filezip_success@2x.129e62e8.png";